import * as actionTypes from "./actionTypes";

export const fileDownloadUrl = (payload, isDialog = false, category, DocDetail, tmpFileGuid = "", originalFileName = "") => ({
  type: actionTypes.FILE_DOWNLOAD_URL,
  payload,
  isDialog,
  category,
  DocDetail,
  tmpFileGuid,
  originalFileName
});
export const fileDownloadUrlFailed = () => ({
  type: actionTypes.FILE_DOWNLOAD_URL_FAILED,
});
export const fileDownloadUrlSuccess = (payload, documentid) => ({
  type: actionTypes.FILE_DOWNLOAD_URL_SUCCESS,
  payload,
  documentid,
});

export const clearFileErrorMessage = () => ({
  type: actionTypes.CLEAR_FILEERROR_MESSAGE,
})

export const fileDownloadurlDialogFailed = (payload) => ({
  type: `${actionTypes.FILE_DOWNLOAD_URL}_DIALOG_FAILED`,
  payload,
});

export const fileUpload = (payload) => ({
  type: actionTypes.FILE_UPLOAD,
  payload,
});
export const fileUploadFailed = (payload) => ({
  type: actionTypes.FILE_UPLOAD_FAILED,
  payload,
});
export const fileUploadSuccess = (payload) => ({
  type: actionTypes.FILE_UPLOAD_SUCCESS,
  payload,
});

export const fileUploadProgress = (payload) => ({
  type: actionTypes.FILE_UPLOAD_PROGRESS,
  payload,
});

export const scanningProcessStatus = (id, from, docObject) => ({
  type: actionTypes.SCANNING_PROCESS_STATUS,
  payload: { id, from, docObject },
});

export const scanningProcessStatusSuccess = (payload) => ({
  type: `${actionTypes.SCANNING_PROCESS_STATUS}_SUCCESS`,
  payload,
});

export const scanningProcessStatusFailed = (payload) => ({
  type: `${actionTypes.SCANNING_PROCESS_STATUS}_FAILED`,
  payload,
});

export const singleFileProgressing = (payload) => ({
  type: actionTypes.SINGLE_FILE_PROGRESSING,
  payload,
});

export const createNewDocVersion = (payload) => ({
  type: actionTypes.CREATE_NEW_DOC_VERSION,
  payload,
});

export const createNewDocVersionSuccess = (payload, from) => ({
  type: `${actionTypes.CREATE_NEW_DOC_VERSION}_SUCCESS`,
  payload,
  from,
});

export const createNewDocVersionFailed = (payload) => ({
  type: `${actionTypes.CREATE_NEW_DOC_VERSION}_FAILED`,
  payload,
});

export const createNewDocVersionCancel = (payload, docObject) => ({
  type: `${actionTypes.CREATE_NEW_DOC_VERSION}_CANCEL`,
  payload,
  docObject,
});

export const filePreviewUrl = (payload, isDropzone, isPreviewAudit, versionId, tmpFileGuid = "", originalFileName = "") => ({
  type: actionTypes.FILE_PREVIEW_URL,
  payload,
  isDropzone,
  isPreviewAudit,
  versionId,
  tmpFileGuid,
  originalFileName
});
export const filePreviewUrlFailed = () => ({
  type: `${actionTypes.FILE_PREVIEW_URL}_FAILED`,
});
export const filePreviewUrlSuccess = (payload, fileName, fileType, requestPayload) => ({
  type: `${actionTypes.FILE_PREVIEW_URL}_SUCCESS`,
  payload,
  fileName,
  fileType,
  requestPayload
});
export const showDownloadLoader = (payload) => ({
  type: `${actionTypes.SHOW_DOWNLOAD_LOADER}`,
  payload
});
export const singleFileErrorToaster = (payload) => ({
  type: `${actionTypes.SINGLE_FILE_ERROR_TOASTER}`,
  payload
})